module.exports = __webpack_public_path__ + "static/media/5-Spades.c28b9b02.svg";